import type { SearchComponentProps } from './SearchComponent';

export const SearchComponent = {
    MountAsync: async (target: HTMLElement, props: SearchComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { SearchComponent } = await import('./SearchComponent');
        return await mountReactComponentAsync(target, SearchComponent, props);
    }
};
